module.exports = __webpack_public_path__ + "img/sejue.e1e8c098.png";